<template>
  <div class="homeRecommend">
    <!-- <router-view /> -->
    <bannerManage />
  </div>
</template>

<script>
import bannerManage from './bannerManage/index.vue';
export default {
  name: 'HomeRecommend',
  components: {
    bannerManage
  },
  data: () => {
    return {
    };
  }
};
</script>
